var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBotGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.528758 0.195262C0.789108 -0.0650874 1.21122 -0.0650874 1.47157 0.195262L5.00016 3.72386L8.52876 0.195262C8.78911 -0.0650874 9.21122 -0.0650874 9.47157 0.195262C9.73192 0.455612 9.73192 0.877722 9.47157 1.13807L5.47157 5.13807C5.21122 5.39842 4.78911 5.39842 4.52876 5.13807L0.528758 1.13807C0.268409 0.877722 0.268409 0.455612 0.528758 0.195262Z",
    fill: "#171E26",
    fillOpacity: 0.56
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBotGray);
export default __webpack_public_path__ + "static/media/arrowBotGray.304915516429e81b293395545970de8e.svg";
export { ForwardRef as ReactComponent };